import { roundToThreeDecimals } from '../../../helpers/modules';
import { convertNumberToWords } from './billFunctions';
import React, { useEffect, useState } from 'react';

const PrintToPdf = ({
	componentRef,
	detailBill,
	billCalculationArr,
	totalNetValue,
	totalArr,
	platformFee,
	hasCompany,
	adminCompany,
	isTunisia,
}) => {
	let itemsPerPage = [11, 15];
	const [countryMap, setCountryMap] = useState({});
	const [countryNames, setCountryNames] = useState({});

	useEffect(() => {
		fetch('https://cdn.jsdelivr.net/npm/world-countries@4/dist/countries.json')
			.then((res) => res.json())
			.then((data) => {
				const map = {};
				const names = {};
				data.forEach((c) => {
					if (c.cca3 && c.cca2) {
						map[c.cca3] = c.cca2.toLowerCase();
						names[c.cca3] = c.name.common;
					}
				});
				setCountryMap(map);
				setCountryNames(names);
			})
			.catch((err) => console.error('Failed to fetch country codes:', err));
	}, []);

	const getFlagUrl = (cca3) => {
		if (!cca3 || !countryMap[cca3]) return null;
		return `https://hatscripts.github.io/circle-flags/flags/${countryMap[cca3]}.svg`;
	};

	const getCountryName = (cca3) => {
		return countryNames[cca3] || cca3;
	};

	const shopCountry = detailBill?.bill?.order_id?.shopInfo?.country;
	const showTimbre = isTunisia !== undefined ? isTunisia : !shopCountry || shopCountry === 'TUN';

	if (Object.keys(detailBill).length === 0) {
		return;
	}

	const hasCompanyCheck =
		hasCompany !== undefined ? hasCompany : detailBill?.clientCompany ? true : false;
	const platformFeeValue =
		platformFee !== undefined ? platformFee : hasCompanyCheck ? totalNetValue * 0.1 : 0;
	const adminLogo = adminCompany?.image?.secure_url || null;

	const renderTableRows = (start, end) => {
		return detailBill?.list?.slice(start, end).map((item, index) => (
			<tr className='elements' key={index}>
				<td>{item?.reference}</td>
				<td>{item?.designation}</td>
				<td>{item?.quantity}</td>
				<td>
					{roundToThreeDecimals(
						(item?.prise_product_HT * item?.quantity) / (1 - item?.remise / 100),
					)}
				</td>
				<td>{item?.remise}%</td>
				<td>{roundToThreeDecimals(item?.prise_product_HT * item?.quantity)}</td>
				<td>{item?.tva} %</td>
			</tr>
		));
	};

	const renderTable = (start, end) => {
		return (
			<div key={start} className='page-content'>
				<div className='devis-table'>
					<table className='offres'>
						<thead>
							<tr id='titres'>
								<td>RÉFÉRENCE</td>
								<td>DÉSIGNATION</td>
								<td>QTÉ</td>
								<td>PRIX UNIT H.T</td>
								<td>REMISE</td>
								<td>MONTANT H.T</td>
								<td>TX.TVA</td>
							</tr>
						</thead>
						<tbody>{renderTableRows(start, end)}</tbody>
					</table>
				</div>
			</div>
		);
	};

	return (
		<div className='bill-pdf-admin' ref={componentRef}>
			{adminLogo && (
				<div className='pdf-logo-container'>
					<img src={adminLogo} alt='Logo société' className='pdf-logo-img' />
				</div>
			)}

			<div className='container'>
				<div className='devis'>
					<h4>FACTURE Proformat</h4>
					<div className='info'>
						<div>
							<label>Numéro:</label>
							<label>Date:</label>
							<label>Référence code client:</label>
						</div>
						<div>
							<span>{detailBill?.bill?.reference}</span>
							<span>12-12-2022</span>
							<span>{detailBill?.bill?.order_id?.clientInfo?.customs_code || '-'}</span>
						</div>
					</div>
				</div>
				<div className='general-info'>
					<div className='left'>
						<h2 className='infos-societe'>🛒 JEUN'ESS MARKET</h2>
						<div className='address'>
							<span>VTE EN GROS ART DE MENAGE</span>
							<span>{detailBill?.bill?.order_id?.superAdminInfo?.address}</span>
						</div>
					</div>
					<div className='right'>
						<h3>{detailBill?.bill?.order_id?.clientInfo?.company_name ?? ''}</h3>
						<p>{detailBill?.bill?.order_id?.clientInfo?.client ?? ''}</p>
						<p>
							Matricule Fiscale:{' '}
							{detailBill?.bill?.order_id?.clientInfo?.tax_registration_number
								? detailBill.bill.order_id.clientInfo.tax_registration_number
								: '-'}
						</p>{' '}
						<p>N° téléphone: {detailBill?.bill?.order_id?.clientInfo?.phone ?? ''}</p>
						<span>{detailBill?.bill?.order_id?.shopInfo.address_number} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo.street} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo.ville} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo.postal_code} </span>
						<span>{detailBill?.bill?.order_id?.shopInfo.region} </span>
						{shopCountry && (
							<div style={{ marginTop: '2px', display: 'flex', alignItems: 'center', gap: '4px' }}>
								{getFlagUrl(shopCountry) && (
									<img
										src={getFlagUrl(shopCountry)}
										alt={getCountryName(shopCountry)}
										width='14'
										height='14'
										style={{ borderRadius: '50%' }}
									/>
								)}
								<span style={{ fontSize: '0.625rem', color: '#0f172a', fontWeight: 300 }}>
									{getCountryName(shopCountry)}
								</span>
							</div>
						)}
					</div>
				</div>

				<div
					className='platform-fee-print'
					style={{
						margin: '4px 0',
						padding: '10px',
						border: hasCompanyCheck ? '2px solid #FFA000' : '2px solid #4CAF50',
						borderRadius: '5px',
						backgroundColor: hasCompanyCheck ? '#FFF3CD' : '#E8F5E9',
					}}
				>
					<h3
						style={{
							margin: '0 0 5px 0',
							fontSize: '12px',
							color: hasCompanyCheck ? '#856404' : '#2E7D32',
						}}
					>
						{hasCompanyCheck
							? '📢 Frais de Plateforme Marketing'
							: '✅ Frais de Plateforme Marketing'}
					</h3>
					{hasCompanyCheck ? (
						<p style={{ margin: '0', fontSize: '10px', color: '#856404' }}>
							<strong>10% du montant total</strong> de cette facture sera prélevé pour la
							plateforme. Montant net à payer :{' '}
							<strong>{roundToThreeDecimals(totalNetValue)} DT</strong> → Frais (10%) :{' '}
							<strong>{roundToThreeDecimals(platformFeeValue)} DT</strong>
						</p>
					) : (
						<p style={{ margin: '0', fontSize: '10px', color: '#2E7D32' }}>
							Aucun frais de marketing n'est appliqué. Frais de plateforme : <strong>0 DT</strong>
						</p>
					)}
				</div>

				<div className='devis-table'>
					{renderTable(0, itemsPerPage[0])}
					{Array.from(
						{ length: Math.ceil((detailBill?.list?.length - itemsPerPage[0]) / itemsPerPage[1]) },
						(_, index) =>
							renderTable(
								itemsPerPage[0] + index * itemsPerPage[1],
								itemsPerPage[0] + (index + 1) * itemsPerPage[1],
							),
					)}
					{detailBill?.list?.length >= 2 && <div style={{ pageBreakAfter: 'always' }} />}
					<div className='billTable'>
						<table id='bt-principal'>
							<tbody>
								<tr id='firstBigRow'>
									<td>
										<table id='bt-nested-1'>
											<thead>
												<tr id='bt-head-1'>
													<td>CODE</td>
													<td>BASE</td>
													<td>TAUX</td>
													<td>TOTAL TAXE</td>
												</tr>
											</thead>
											<tbody>
												{billCalculationArr?.map((el, index) => (
													<tr className='bt-tl-1' key={index}>
														<td>{el.CODE}</td>
														<td>{roundToThreeDecimals(el.BASE)}</td>
														<td>{el.TAUX}%</td>
														<td>{roundToThreeDecimals(el.TOTAL_TAXE)}</td>
													</tr>
												))}
												{showTimbre && (
													<tr className='bt-tl-1'>
														<td>CTI</td>
														<td>0.000</td>
														<td />
														<td>1 DT</td>
													</tr>
												)}
												{showTimbre && (
													<tr className='bt-tl-1'>
														<td>Timbre</td>
														<td>0.000</td>
														<td />
														<td>1 Dt</td>
													</tr>
												)}
											</tbody>
										</table>
									</td>
									<td>
										<table id='bt-nested-2'>
											<thead>
												<tr id='bt-head-2'>
													<td>TOTAL H.T</td>
													<td>REMISE</td>
													<td>ESCOMPTE</td>
													<td>TOTAL TTC</td>
												</tr>
											</thead>
											<tbody>
												{billCalculationArr?.map((el, index) => (
													<tr className='bt-tl-2' id='bt-tl-2' key={index}>
														<td>{roundToThreeDecimals(el.BASE)}</td>
														<td>{roundToThreeDecimals(el.REMISE)}</td>
														<td>0.000</td>
														<td>{roundToThreeDecimals(el.TOTAL_TCC)}</td>
													</tr>
												))}
												<tr className='bt-tl-2'>
													<td />
													<td />
													<td />
													<td />
												</tr>
												<tr className='bt-tl-2'>
													<td />
													<td />
													<td />
													<td />
												</tr>
											</tbody>
										</table>
									</td>
									<td>
										<table id='bt-nested-3'>
											<thead>
												<tr id='bt-head-3'>
													<td>NET A PAYER</td>
												</tr>
											</thead>
											<tbody>
												<tr className='bt-tl-3'>
													<td>{totalNetValue}</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
								<tr id='secondBigRow'>
									<td>
										<table id='bt-nested-4'>
											<tbody>
												<tr className='bt-head-4'>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
												</tr>
												<tr className='bt-head-4'>
													<td></td>
													<td></td>
													<td></td>
													<td></td>
												</tr>
												{totalArr}
											</tbody>
										</table>
									</td>
									<td>
										<table id='bt-nested-5'>
											<thead>
												<tr id='bt-head-5'>
													<td>CONDITIONS DE REGLEMENT:</td>
													<td></td>
												</tr>
											</thead>
											<tbody>
												<tr className='bt-tl-5'>
													<td></td>
													<td></td>
												</tr>
												<tr className='bt-tl-5'>
													<td>90 JOURS</td>
													<td></td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</tbody>
						</table>
						<div className='billEnd'>
							<h2>ARRETER LA PRÉSENTE FACTURE À LA SOMME DE : </h2>
							<span>{convertNumberToWords(parseInt(totalNetValue * 1000))}</span>
						</div>
					</div>
				</div>
				<div className='footer'>
					<div className='footer'>
						<div className='left'>
							<ul>
								<li>
									Nom de Société : <strong>{detailBill?.companies?.[0]?.name || '-'}</strong>
								</li>
								<li>Addresse : {detailBill?.companies?.[0]?.address || '-'}</li>
								<li>
									CODE TVA : <span>{detailBill?.companies?.[0]?.tva_code || '-'}</span>
								</li>
								<li>
									RC : <span>{detailBill?.companies?.[0]?.r_c || '-'}</span>
								</li>
								<li>
									Code en Douane : <span>{detailBill?.companies?.[0]?.customs_code || '-'}</span>
								</li>
							</ul>
						</div>
						<div className='left'>
							<ul>
								<li>
									Tél : <span>{detailBill?.companies?.[0]?.phone || '-'}</span>
								</li>
								<li>
									Fax : <span>{detailBill?.companies?.[0]?.fax || '-'}</span>
								</li>
								<li>
									Email : <span>{detailBill?.companies?.[0]?.email || '-'}</span>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrintToPdf;
